import { Store } from "vuex";
import { store } from "@/shared-store";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { MerchantCountry } from "@/types/merchant";
import { computed, ComputedRef } from "vue";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";
import { PagesTypes } from "@/apps/merchant3/types/PagesTypes";
import { CartActiveFeatures } from "@/apps/merchant3/types/CartActiveFeatures";
import {directToCustomerRoutes} from "@/apps/merchant3/router/directToCustomerRoutes";
import router from "@/router";

const merchantCountry = (): string => {
  const vuexStore = store as unknown as Store<IVuexState>;

  return vuexStore?.state.merchant?.merchant?.country || "";
};

export const isMexicoSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.MX;
};

export const isSouthAfricaSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.ZA;
};

export const isEcuadorSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.EC;
};

export const isBrazilSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.BR;
};

export const isColombiaSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.CO;
};

export const isPeruSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.PE;
};

export const isPanamaSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.PA;
};

export const isPhilippinesSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.PH;
};

export const isIndonesiaSaleFlow = (): boolean => {
  return merchantCountry() === MerchantCountry.ID;
};

export const isRentalFlow: ComputedRef<boolean> = computed(() =>
  store.getters["carts/hasActiveFeature"](CartActiveFeatures.RENTAL_MODEL)
);

export const isSubscriptionFlow: ComputedRef<boolean> = computed(() =>
  store.getters["carts/hasActiveFeature"](CartActiveFeatures.SUBSCRIPTION_MODEL)
);

export const isEcommerceFlow = computed(() => {
  const vuexStore = store as unknown as Store<IVuexState>;
  return vuexStore?.state.carts?.productVersion === ProductVersion.M3_ECOMMERCE;
});

export const isDirectToCustomerFlow: ComputedRef<boolean> = computed(() =>
  store.getters["carts/hasActiveFeature"](
    CartActiveFeatures.CHECKOUT_ON_DIRECT_TO_CUSTOMER
  ) || directToCustomerRoutes.some(route => route.name === router.currentRoute.value.name)
);

const secondPagesOfEcommerceFlow = [
  PagesTypes.M3_Software,
  PagesTypes.M3_Complete,
];

export const is2StepFlowInFirstPart = (): ComputedRef<boolean> => computed(() => {
  const vuexStore = store as unknown as Store<IVuexState>;

  if (
    isEcommerceFlow.value &&
    !secondPagesOfEcommerceFlow.includes(vuexStore.state.carts.currentPage)
  ) {
    return true;
  }

  return !!sessionStorage.getItem("isKiosk");
});

export const isSpanishFlow = (): boolean => {
  return (
    isMexicoSaleFlow() ||
    isEcuadorSaleFlow() ||
    isColombiaSaleFlow() ||
    isPeruSaleFlow() ||
    isPanamaSaleFlow()
  );
};

export const isEsignV2Country = (): boolean => {
  return isColombiaSaleFlow() || isPanamaSaleFlow() || isMexicoSaleFlow();
};
